import { Injectable } from '@angular/core';
import { CanMatch, Route, UrlSegment } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { CacheService } from '../../shared/services/cache.service';
import { FormatterUtil } from '../../utils/formatter-util';

/**
 * Matches a top-level URL segment (e.g. /black-friday) when it is a known
 * festivities / event campaign slug from cache. Tried before ValidCategoryGuard
 * so event URLs can share the same path shape as pack gallery slugs.
 */
@Injectable({ providedIn: 'root' })
export class ValidEventCategoryGuard implements CanMatch {
  constructor(private cacheService: CacheService) {}

  canMatch(_route: Route, segments: UrlSegment[]): Observable<boolean> {
    if (!segments.length) {
      return of(false);
    }
    const segment = segments[0].path;
    return this.cacheService.getEventCategoriesFromCache().pipe(
      take(1),
      map((events) => {
        const validSlugs = events
          .map((e) =>
            e.eventName ? FormatterUtil.formatToKebabCase(e.eventName).toLowerCase() : ''
          )
          .filter(Boolean);
        return validSlugs.includes(segment.toLowerCase());
      }),
      catchError(() => of(false))
    );
  }
}
